/**
 * `LocalizedText`, as the browser reads it, and the ONE resolution chain.
 *
 * The platform writes bilingual client-facing strings as `{en, fr}`
 * (`core_models_services/src/models/i18n.py`). They reach the browser verbatim —
 * in a projected view, or straight off a catalog-tier document — and every
 * reader resolves them the same way: requested locale, then `en`, then whatever
 * is there. The region tag is stripped first because `plugins/i18n.ts` sets the
 * runtime locale to the raw browser tag (`fr-FR`) while the maps are keyed `fr`.
 *
 * Lives here rather than beside one feature's DTOs: the chain is platform-wide
 * (MYAC-1381 made the referential catalogue its second reader).
 */

/** `{en: "...", fr: "..."}` — LocalizedText's serialized shape. */
export type LocalizedTextMap = Record<string, string>

/** Resolve against the UI locale: `requested -> en -> any`, never the key. */
export function resolveLocalized(text: LocalizedTextMap | undefined, locale: string): string {
  if (!text) return ''
  const base = locale.split('-')[0].toLowerCase()
  return text[base] ?? text.en ?? Object.values(text)[0] ?? ''
}
